export default "__VITE_ASSET__0FjdxUpy__"